import script from "./DownloadFaqSection.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadFaqSection.vue?vue&type=script&setup=true&lang=js"

import "./DownloadFaqSection.vue?vue&type=style&index=0&id=1b6dc4c2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b6dc4c2"]])

export default __exports__